import { render } from "./PoliticaConfidentialitate.vue?vue&type=template&id=465d1619&scoped=true"
import script from "./PoliticaConfidentialitate.vue?vue&type=script&lang=js"
export * from "./PoliticaConfidentialitate.vue?vue&type=script&lang=js"

import "./PoliticaConfidentialitate.vue?vue&type=style&index=0&id=465d1619&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-465d1619"]])

export default __exports__